class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity({
        line: this.dataset.index,
        quantity: 0,
        id: this.dataset.id
      });
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  rerenderProductCarousel() {
    const wrapper = this.closest('cart-items') || this.closest('cart-drawer-items');
    const shouldRerenderCarousel = wrapper?.querySelector('[data-should-rerender-carousel]')?.getAttribute('data-should-rerender-carousel') === 'true';
    const carouselSelector = wrapper?.querySelector('[data-should-rerender-carousel]')?.getAttribute('data-slider');
    if (shouldRerenderCarousel && carouselSelector) {
      window.slickReinit(carouselSelector);
    }
  }

  onChange(event) {
    this.updateQuantity({
      line: event.target.dataset.index,
      quantity: event.target.value,
      name: document.activeElement.getAttribute('name'),
      id: event.target.dataset.id
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart').dataset.id,
        selector: '#main-cart-items .js-contents',
      },
      {
        id: 'cart-product-carousel',
        section: document.getElementById('main-cart').dataset.id,
        selector: '#cart-product-carousel .js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-main-cart-footer',
      }
    ];
  }

  updateThresholdsMessage(totalPrice) {
    const thresholds = document.querySelector('[data-thresholds-message]');
    if (!thresholds) return;

    const freeShippingMessage = thresholds.dataset.freeShippingMessage;
    const awayShippingMessage = thresholds.dataset.awayShippingMessage;
    const thresholdInCents = thresholds.dataset.thresholdInCents;
    let thresholdsMessage = "";

    if (totalPrice >= thresholdInCents) {
      thresholdsMessage = freeShippingMessage;
    } else {
      const away = (Number(thresholdInCents) - Number(totalPrice)) / 100.00;
      thresholdsMessage = awayShippingMessage.replace('$value', `$${away}`)
    }

    thresholds.innerHTML = thresholdsMessage;
  }

  updateQuantity({
    line, quantity, name, id
  }) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          const html = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          elementToReplace.innerHTML = html;
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
        this.updateThresholdsMessage(parsedState.total_price);
        this.rerenderProductCarousel();
      })
      .then(() => {
        if (quantity <= 0) {
          const attributes = window.cartAttributes || {};
          let fragile_goods_ids = attributes.fragile_goods_ids;
          if (fragile_goods_ids && fragile_goods_ids?.includes(id)) {
            fragile_goods_ids = fragile_goods_ids.split(',').filter((item) => item !== id);
            fragile_goods_ids = fragile_goods_ids.length > 0 ? fragile_goods_ids.join(',') : null;
          }
          const body = JSON.stringify({ attributes: {fragile_goods_ids } });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then(response => window.cartAttributes = response.attributes)
        }
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
